// extracted by mini-css-extract-plugin
module.exports = {"customerService":"styles_customerService__H3NYc","title":"styles_title__4U3fV","buttonItem":"styles_buttonItem__7wSv_","liveBtn":"styles_liveBtn__MePkU"};